import React from 'react' 
import UpgradeToGetStarted from '../../components/UpgradeToGetStarted/UpgradeToGetStarted'
import { Box, Button, Typography } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';
const PeopleTeams = () => {
      const navigate = useNavigate();
  return (
    <div>
         <Box>
                <Button
                  onClick={() => navigate('/reports')}
                  style={{
                    color: '#1A1F36',
                    fontSize: '24px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    marginBottom: '24px',
                    textTransform:"capitalize",
                  }}
                >
                  <KeyboardArrowLeftIcon
                    sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                  />
                  Reports
                </Button>
              </Box> 
       <UpgradeToGetStarted
      imageSrc="/assets/images/blank-page/people-teams.png"
      imageAlt="people-teams"
      heading="Teams"
      description="Easily add members and projects to teams, assign team leads with special permissions, and filter data by team for better organization."
      lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
      promoText="Schedule a call with our sales team to discover more about Teams."
      buttonText="Upgrade to get started"
      showTextContent={true}
    />
    </div>
  )
}

export default PeopleTeams
